import React, { useMemo } from 'react';

import { ProductDetailsSimilarProducts } from '@components/product/ProductDetailsSimilarProducts';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';
import { convertProductProps } from '@utils/products';

import { useProductDetailsSimilarProductsListQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsSimilarProductsContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data, loading } = useProductDetailsSimilarProductsListQuery({
    variables: {
      productId,
      perPage: 8,
    },
    context: {
      batch: true,
    },
  });

  const products = useMemo(() => {
    return data?.productDetailsSimilarProducts?.map((product) => {
      if (product) {
        return convertProductProps(product);
      }

      return null;
    }).filter((product) => !!product);
  }, [data?.productDetailsSimilarProducts]);

  if (loading) {
    return (
      <div className={className}>
        <ProductsFeedSleketon count={4} />
      </div>
    );
  }

  if (products?.length) {
    return (
      <ProductDetailsSimilarProducts
        className={className}
        products={products}
      />
    );
  }

  return null;
};
